import { atom } from 'jotai';
import type { SerializeFrom } from '@remix-run/server-runtime';
// The path to the action might need adjustment depending on the final file structure
// Assuming the action is in the main search route file.
import type { action } from '~/routes/_app.rocco.search.$';

type SearchPageData = SerializeFrom<typeof action>;

/**
 * Jotai atom to store the search page data fetched from the action.
 * This allows sharing the fetched data across different components on the search page
 * without prop drilling or re-fetching.
 */
export const searchPageDataAtom = atom<SearchPageData | null>(null);
export const searchPageDataLoadingAtom = atom<boolean>(false);
export type { SearchPageData };
